import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role } from '../models/role';
import { User } from '../models/user';
import { UserService } from '../services/user.service';
import {LocationApiKey} from "../models/locationconfig";

@Component({
  selector: 'app-apikey-dialog',
  templateUrl: './apikey-dialog.component.html',
  styleUrls: ['./apikey-dialog.component.sass'],
  standalone: false
})
export class ApikeyDialogComponent implements OnInit {
  user: User;
  apiKey: LocationApiKey;
  initialEnabled: boolean;

  constructor(
      private dialogRef: MatDialogRef<ApikeyDialogComponent>,
      private userService: UserService,
      @Inject(MAT_DIALOG_DATA) apiKey:LocationApiKey,
  ) {
    this.userService.getUserRole().then((user) => {
      this.user = user;
    });

    if (!apiKey) {
      this.apiKey = new LocationApiKey();
    } else {
      this.apiKey = Object.assign({}, apiKey);
    }
    this.initialEnabled = this.apiKey.enabled;
  }

  ngOnInit() {
  }

  save() {
    if (this.initialEnabled != this.apiKey.enabled) {
      this.apiKey.lastModifiedBy = this.user ? this.user.Email : 'RemoteAG Admin Tool';
      this.apiKey.lastModifiedDateTime = new Date().toISOString();
    }

    this.dialogRef.close(this.apiKey);
  }

  close() {
    this.dialogRef.close();
  }

  isEnabled(value: string): boolean {
    switch (this.user?.Role) {
      case Role.Admin:
      case Role.Maintainer:
        return true;
      default:
        return false;
    }
  }
}
